import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { CursorType } from '../../../configs/constant';
import { IGateway } from '../../../services/gateway.service';
import { ControlLocationGatewayType } from 'services/control.service';

type GatewayState = {
  gateways: IGateway[];
  cursor: CursorType;
  limit: number;
  total: number;
  gatewayControl: any;
};

const initialState: GatewayState = { gateways: [], cursor: {}, limit: 10, total: 0, gatewayControl: {} };

const slice = createSlice({
  name: 'gatewayState',
  initialState: initialState,
  reducers: {
    setGateways: (
      state,
      {
        payload: { gateways, cursor, total },
      }: PayloadAction<{ gateways: IGateway[]; cursor: CursorType; total: number }>
    ) => {
      state.gateways = gateways;
      state.cursor = cursor;
      if (typeof total === 'number') {
        state.total = total;
      }
    },
    setGatewayControl: (state, { payload }: PayloadAction<{ payload: ControlLocationGatewayType }>) => {
      state.gatewayControl = payload;
    },
    setLimit: (state, { payload: { limit } }: PayloadAction<{ limit: number }>) => {
      state.limit = limit;
    },
    setCursor: (state, action: PayloadAction<CursorType>) => {
      state.cursor = action.payload;
    },
  },
});

export const { setGateways, setLimit, setCursor, setGatewayControl } = slice.actions;

export default slice.reducer;

export const selectGatewayState = (state: RootState) => state.gatewayState;
export const selectGateway = (state: RootState) => state.gatewayState.gateways;
export const selectCursor = (state: RootState) => state.gatewayState.cursor;
export const selectGatewayControl = (state: RootState) => state.gatewayState.gatewayControl;
